
if (!window.dAgency) window.dAgency = {};
window.dAgency.initImageVideoSnippet = (imageVideoSnippet) => {
  if (!imageVideoSnippet) return;

  const mobileVideoItem = imageVideoSnippet.querySelector('.image-video-banner__video--mobile');
  const desktopVideoItem = imageVideoSnippet.querySelector('.image-video-banner__video--desktop');
  const videoControllerDesktop = imageVideoSnippet.querySelector('.image-video-banner__video__controller--desktop');
  const videoControllerMobile = imageVideoSnippet.querySelector('.image-video-banner__video__controller--mobile');

  if (!mobileVideoItem || !desktopVideoItem || ! videoControllerDesktop || ! videoControllerMobile) return;

  if (desktopVideoItem) {
    videoControllerDesktop.addEventListener('mousedown', function(){
      if(desktopVideoItem.paused) {
        desktopVideoItem.play();
        videoControllerDesktop.classList.add('play');
      }
      else {
        desktopVideoItem.pause();
        videoControllerDesktop.classList.remove('play');
      }
    });
  }

  if (mobileVideoItem) {

    videoControllerMobile.addEventListener('mousedown', function(){
      if(mobileVideoItem.paused) {
        mobileVideoItem.play();
        videoControllerMobile.classList.add('play');

      }
      else {
        mobileVideoItem.pause();
        videoControllerMobile.classList.remove('play');
      }
    });
  }
}

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.image-video-banner__container'),
    (imageVideoSnippet) => {
      window.dAgency.initImageVideoSnippet(imageVideoSnippet);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.image-video-banner__container'),
      (imageVideoSnippet) => {
        window.dAgency.initImageVideoSnippet(imageVideoSnippet);
      },
    );
  });
}
